import React from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Shell from "../components/Shell";
import ProjectGridCard from "../components/ProjectGridCard";
import { TagChip } from "../components/bits";
import { endpoints } from "../lib/api";
import * as store from "../lib/storage";

export default function TagPage() {
  const { tag } = useParams();
  const navigate = useNavigate();
  const decoded = decodeURIComponent(tag);
  const [projects, setProjects] = React.useState([]);
  const [tagInfo, setTagInfo] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    window.scrollTo(0, 0);
    endpoints.projects({ tags: decoded, session_id: store.getSessionShuffle() }).then((d) => { setProjects(d.projects); setLoading(false); }).catch(() => setLoading(false));
    endpoints.tags().then((ts) => setTagInfo(ts.find((t) => t.tag === decoded))).catch(() => {});
  }, [decoded]);

  return (
    <Shell>
      <div className="mx-auto w-full max-w-6xl px-4 py-6">
        <Link to="/explore" className="mb-3 flex items-center gap-1.5 text-[14px] font-semibold text-on-dark-muted hover:text-white"><ArrowLeft size={16} /> Browse all</Link>
        <div className="mb-5 flex flex-wrap items-center gap-3">
          <TagChip tag={decoded} selected />
          <h1 className="font-display text-[26px] font-extrabold text-white">{decoded.replace("#", "")} projects</h1>
        </div>
        {tagInfo && <p className="mb-5 text-on-dark-muted">{tagInfo.description}</p>}

        <button onClick={() => navigate(`/deck?tag=${encodeURIComponent(decoded)}`)} className="mb-5 rounded-pill bg-violet-500 px-5 py-2 font-bold text-white" data-testid="tag-swipe-these">Swipe these →</button>

        {loading ? <p className="text-on-dark-muted">Loading…</p> : (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
            {projects.map((p) => <ProjectGridCard key={p.id} project={p} />)}
          </div>
        )}
      </div>
    </Shell>
  );
}
